import { render, staticRenderFns } from "./BusFaq.vue?vue&type=template&id=77cf1da2&scoped=true&"
import script from "./BusFaq.vue?vue&type=script&lang=js&"
export * from "./BusFaq.vue?vue&type=script&lang=js&"
import style0 from "./BusFaq.vue?vue&type=style&index=0&id=77cf1da2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cf1da2",
  null
  
)

export default component.exports